
<template>
  <!--楼栋管理-->
  <div>
    <x-tabula
      ref="table"
      :searchList="searchList"
      rowKey="buildingId"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      @resetSearch = "resetSearch"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'building',
  data () {
    return {
      searchList: [
        { label: '', props: ['communityId'], placeholder: '选择小区', options: [], inputType: 'select', fetchOptions: this.getOptions },
        { label: '', props: ['keywords'], placeholder: '楼栋名、编号', inputType: 'input' },
        { label: '', props: ['createDate'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        {
          label: '',
          props: ['areas'],
          placeholder: '选择省市',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(3, 'searchList', '1,2,3', e);
          }
        },
        { label: '', props: ['propertyId'], placeholder: '选择物业', options: [], inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:building:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:building:remove'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:building:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:building:remove'] }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '所属小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '楼栋名', dataIndex: 'buildingName', align: 'left', width: '' },
        { title: '楼栋编号', dataIndex: 'buildingNo', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      searchParams: {
        keywords: undefined,
        communityId: undefined,
        createDate: undefined,
        areas: undefined,
        propertyId: undefined
      },
      listApi: {
        url: '/building/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addBuilding',
        addTitle: '新增楼栋',
        editTitle: '修改楼栋'
      },
      deleteParam: {
        url: '/building/',
        param: {pk_key: 'buildingId', pk_val: ''},
        title: '楼栋',
        key: 'buildingName'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(3);
      this.propertySelect(4);
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
